import pick from "lodash/pick";
import * as React from "react";
import { Loader } from "@xingternal/crate-communication-loader";
import { useHost } from "@xingternal/crate-core-runtime-helper";
import { xingConnect } from "@xingternal/frame-data-provider";
const injectHasUser = xingConnect((d) => pick(d, "hasUser"));
const InnerWaitForUser = ({
  children,
  hasUser
}) => {
  const { isServer } = useHost();
  if (hasUser || isServer) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, children);
  } else {
    return /* @__PURE__ */ React.createElement(Loader, null);
  }
};
const WaitForUser = injectHasUser(InnerWaitForUser);
export {
  WaitForUser
};
